import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { openDB } from 'idb';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import PageHeader from '../../components/PageHeader';
import '../../styles/Collections.scss';
import Loading from '../../components/Loading';
import logo from '../../images/of-logo.png';
import { toDataURL } from '../../utils/offline-image';

export default function Brands({subView, setSubView, isOffline}) {

    const [collections, setCollections] = useState([])
    const [isLoading, setIsLoading] = useState(true)
  
    const getCollections = async () => {
        let getCollections;
        const getDB = await openDB('scojoapp')
        if (isOffline) {
            const getDB = await openDB('scojoapp')
            let getCollectionsData = await getDB.getAllFromIndex('collections', 'parent_id', 51)
            getCollections = []
            for (let i=0; i < getCollectionsData.length; i++) {
                if (getCollectionsData[i].download) {
                    getCollections.push({
                        ...getCollectionsData[i],
                        image_data_url: await toDataURL(getCollectionsData[i].image_url)
                    })
                }
            }
            getCollections.sort((a,b) => a.sort_order - b.sort_order)
        }

        else {
            getCollections = await getDB.getAllFromIndex('collections', 'parent_id', 51)
            getCollections.sort((a,b) => a.sort_order - b.sort_order)
        }
      
        setCollections(getCollections)
        setIsLoading(false)
    }
  
    useEffect(() => {
     getCollections()
    }, []);

  return (
    isLoading ?
        <Loading light={true} />
    :
        <Box className='app-sub-page collection'>
            <Box className='collection-grid brands'>
                <Grid container direction="row" className='collection-grid-container' style={{marginBottom: '50px'}}>
                    <Grid key={'000'} item className="collection-grid-item">
                        <img className='collection-grid-image-header' src={logo} alt={'The Optical Foundry'} style={{maxWidth: '300px'}} />
                    </Grid>
                    {collections.length > 0 &&
                        collections.map((c) => {
                            let imgSrc = c.image_url
                            if (c.image_data_url) {
                                imgSrc = c.image_data_url;
                            }
                            return (
                                <Grid key={c.id} item className="collection-grid-item">
                                    <Button className='collection-grid-btn' onClick={(e) => setSubView({view: 'collections', id: c.id, name: c.name, last: subView})}>
                                        <img className='collection-grid-image' src={imgSrc} alt={c.name} />
                                    </Button>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Box>
        </Box>
  )
}
